<template>
  <div class="page-title">{{ $t("profile_page_title") }}</div>
  <div class="intro">{{ $t("profile_subtitle") }}</div>
  <el-row>
    <el-col :span="24">
      <el-row>
        <el-col class="container" :span="24">
          <el-row :gutter="12">
            <el-col :span="24">
              <div class="subtitle">{{ $t("login_data") }}</div>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  :placeholder="$t('old_password')"
                  show-password
                  v-model="old_password"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  :placeholder="$t('new_password')"
                  show-password
                  v-model="password"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="store.state.login_type == 'mandate'">
            <el-col :span="24">
              <div class="subtitle">{{ $t("calender_view_dht") }}</div>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color") }}</div>
                <el-color-picker
                  v-model="bgColor"
                  @active-change="BGColorChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color") }}</div>
                <el-color-picker
                  v-model="textColor"
                  @active-change="TextColorChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color_service") }}</div>
                <el-color-picker
                  v-model="bgColorService"
                  @active-change="BGColorServiceChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color_service") }}</div>
                <el-color-picker
                  v-model="textColorService"
                  @active-change="TextColorServiceChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color_today") }}</div>
                <el-color-picker
                  v-model="bgColorToday"
                  @active-change="BGColorTodayChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color_today") }}</div>
                <el-color-picker
                  v-model="textColorToday"
                  @active-change="TextColorTodayChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color_announcements") }}</div>
                <el-color-picker
                  v-model="bgColorAnnouncement"
                  @active-change="BGColorAnnouncementChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color_announcements") }}</div>
                <el-color-picker
                  v-model="textColorAnnouncement"
                  @active-change="TextColorAnnouncementChanged"
                ></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="container" :span="24">
          <el-row>
            <el-col :span="24" v-if="store.state.login_type != 'mandate'">
              &nbsp;
            </el-col>
            <el-col :span="24" v-if="store.state.login_type == 'mandate'">
              <div class="subtitle">{{ $t("frontend_view_calendar") }}</div>
            </el-col>
            <el-col :span="24" v-if="store.state.login_type == 'mandate'">
              <el-image v-if="logo" :src="logo" :key="imageKey">
                <template #placeholder>
                  <div class="image-slot">
                    {{ $t("loading") }}
                  </div>
                </template>
              </el-image>
              <div
                class="calendar-preview"
                :style="{
                  backgroundColor: bgColor
                }"
              >
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColorToday,
                      color: textColorToday
                    }"
                  >
                    16. ({{ $t("today") }})
                  </div>
                  <div
                    class="c-content"
                    :style="{ backgroundColor: bgColorToday }"
                  >
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorAnnouncement }"
                    >
                      <div
                        class="time"
                        :style="{ color: textColorAnnouncement }"
                      >
                        10:00 Uhr<br />bis 16:00 Uhr
                      </div>
                      <div
                        class="title"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Musterfirma
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Beispieltätigkeit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColor,
                      color: textColor
                    }"
                  >
                    17.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColor,
                      color: textColor
                    }"
                  >
                    18.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColor,
                      color: textColor
                    }"
                  >
                    19.
                  </div>
                  <div class="c-content">
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorService }"
                    >
                      <div class="time" :style="{ color: textColorService }">
                        10:45
                      </div>
                      <div class="title" :style="{ color: textColorService }">
                        Musterfirma
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorService }"
                      >
                        Beispieltätigkeit
                      </div>
                    </div>
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorAnnouncement }"
                    >
                      <div
                        class="time"
                        :style="{ color: textColorAnnouncement }"
                      >
                        10:00 Uhr<br />bis 16:00 Uhr
                      </div>
                      <div
                        class="title"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Musterfirma
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Beispieltätigkeit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{ backgroundColor: bgColor, color: textColor }"
                  >
                    20.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{ backgroundColor: bgColor, color: textColor }"
                  >
                    21.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{ backgroundColor: bgColor, color: textColor }"
                  >
                    22.
                  </div>
                  <div class="c-content">
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorAnnouncement }"
                    >
                      <div
                        class="time"
                        :style="{ color: textColorAnnouncement }"
                      >
                        10:25 Uhr<br />bis 13:05 Uhr
                      </div>
                      <div
                        class="title"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Musterfirma 2
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Beispieltätigkeit 2
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" style="margin-top:24px;">
              <el-form-item>
                <el-button type="primary" round @click="save()">{{
                  $t("save")
                }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="store.state.login_type == 'mandate'">
            <el-row>
              <el-col :span="24">
                <div class="subtitle">{{ $t("upload_logo") }}</div>
              </el-col>
              <el-col :span="24" align="top">
                <el-form-item>
                  <el-upload
                    :show-file-list="false"
                    class="upload-logo"
                    drag
                    :http-request="handleRequest"
                    :multiple="false"
                    accept="image/png, image/jpg, image/jpeg, image/gif"
                  >
                    <i class="el-icon-upload"></i>
                    <div
                      class="el-upload__text"
                      v-html="$t('upload_field_text')"
                    ></div>
                    <template #tip>
                      <div class="el-upload__tip">
                        {{ $t("logo_advise") }}
                      </div>
                    </template>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-popconfirm
                    :confirmButtonText="$t('yes')"
                    :cancelButtonText="$t('no')"
                    :title="$t('deleted_logo_confirm')"
                    @confirm="deleteLogo()"
                  >
                    <template #reference>
                      <el-button type="primary" round>{{
                        $t("delete_logo")
                      }}</el-button>
                    </template>
                  </el-popconfirm>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="store.state.login_type == 'mandate'">
              <el-col :span="24">
                <div class="subtitle">{{ $t("profile_settings") }}</div>
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  status-icon
                  ref="ruleForm"
                >
                  <el-form-item>
                    <el-checkbox
                      v-model="email_notification"
                      :label="$t('send_email_onadd')"
                      border
                    ></el-checkbox>
                  </el-form-item>
                  <el-form-item prop="email" v-if="email_notification">
                    <el-input
                      :placeholder="$t('email_address')"
                      type="email"
                      v-model="ruleForm.email"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox
                      v-model="enable_notices"
                      :label="$t('notices_field_avaible')"
                      border
                    ></el-checkbox>
                  </el-form-item>

                  <el-form-item>
                    <el-checkbox
                      v-if="enable_notices"
                      v-model="email_notification_notice"
                      :label="$t('send_email_notice')"
                      border
                    ></el-checkbox>
                    <el-form-item
                      prop="email_notice"
                      v-if="email_notification_notice && enable_notices"
                    >
                      <el-input
                        :placeholder="$t('email_address')"
                        type="email"
                        v-model="ruleForm.email_notice"
                      ></el-input>
                    </el-form-item>
                  </el-form-item>
                  <el-form-item prop="showannoucement_inrange_day">
                    <div class="subtitle subtitle_small">
                      {{ $t("showannoucement_inrange_day") }}
                    </div>
                    <el-input
                      style="width:80px;"
                      type="number"
                      min="-1"
                      max="30"
                      :placeholder="$t('showannoucement_inrange_day')"
                      v-model="ruleForm.showannoucement_inrange_day"
                    ></el-input
                    ><span v-if="ruleForm.showannoucement_inrange_day == -1">{{
                      $t("showannoucement_inrange_day_notactive")
                    }}</span>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      type="primary"
                      round
                      @click="save_settings('ruleForm')"
                      >{{ $t("save") }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.el-col {
  background-color: $gkt-light-grey;
}

.el-color-picker {
  border-radius: 40px !important;

  :deep(.el-color-picker__trigger) {
    border-radius: 40px !important;

    :deep(.el-color-picker__color-inner) {
      border-radius: 40px !important;
    }
  }
}

.calendar-preview {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gkt-orange;
  border-radius: 24px;
  background-color: #ffffff;
  overflow: hidden;

  .child {
    flex: 0 0 14.28%;
    height: 275px;

    .c-title {
      font-weight: bold;
      padding: 6px 12px;
      background-color: $gkt-light-grey;
      border-bottom-width: 4px;
      border-bottom-style: solid;
      border-bottom-color: darken($gkt-light-grey, 5);
      border-right: 4px solid darken($gkt-light-grey, 5);
    }

    .c-content {
      padding: 6px;
      height: 100%;
      min-height: 126px;
      border-right: 4px solid darken($gkt-light-grey, 5);

      .preview {
        border-radius: 24px;
        padding: 12px;
        position: relative;
        height: 102px;
        min-height: 100px;
        margin-bottom: 12px;

        .time,
        .title,
        .subtitle {
          position: absolute;
        }

        .time {
          line-height: 14px;
          bottom: 12px;
          right: 12px;
        }

        .title {
          font-size: 18px;
          left: 12px;
          top: 12px;
          font-weight: bold;
        }

        .subtitle {
          top: 36px;
          left: 12px;
          font-size: 14px;
        }
      }
    }

    &:first-child {
      border-top-left-radius: 24px;

      .c-title {
        border-top-left-radius: 24px;
        border-right: 4px solid darken($gkt-light-grey, 5);
      }

      .c-content {
        border-right: 4px solid darken($gkt-light-grey, 5);
      }
    }

    &:last-child {
      border-top-right-radius: 24px;
      flex: 0 0 14.32%;

      .c-title {
        border-top-right-radius: 24px;
        border-right: 0;
      }

      .c-content {
        border-right: 0;
      }
    }
  }
}

.subtitle {
  font-size: 21px;
  font-weight: 500;
  color: $gkt-orange-rgba;
  margin-bottom: 12px;
}
.subtitle_small {
  font-size: 16px;
}

.container {
  padding: 24px 48px;
}
</style>
<style>
.el-form-item__error {
  color: #e79c50 !important;
}
</style>
<script>
import axios from "axios";
import { provide } from "vue";
import store from "@/store";

export default {
  name: "profile",
  setup() {
    provide("store", store);
  },
  data() {
    var validateEmail1 = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("enter_email")));
      } else if (!this.testEmailasList(value)) {
        callback(new Error(this.$t("enter_valid_email")));
      } else {
        callback();
      }
    };
    var validateDays = (rule, value, callback) => {
      value = parseInt(value);

      if (value === "") {
        callback(new Error(this.$t("showannoucement_inrange_day_error")));
      } else if (!Number.isInteger(value)) {
        callback(new Error(this.$t("showannoucement_inrange_day_error")));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        email: "",
        email_notice: "",
        showannoucement_inrange_day: -1
      },
      rules: {
        email: [{ validator: validateEmail1, trigger: "blur" }],
        email_notice: [{ validator: validateEmail1, trigger: "blur" }],
        showannoucement_inrange_day: [
          { validator: validateDays, trigger: "blur" }
        ]
      },
      imageKey: 0,
      store,
      password: "",
      old_password: "",
      logo: null,
      bgColor: "#FFFFFF",
      textColor: "#000000",
      bgColorService: "#FFFFFF",
      textColorService: "#000000",
      bgColorToday: "#D0D0D0",
      textColorToday: "#000000",
      bgColorAnnouncement: "#D0D0D0",
      textColorAnnouncement: "#7F1010",
      email_notification: false,
      email_notification_notice: false,
      enable_notices: false,
      showannoucement_inrange_day: -1
    };
  },
  methods: {
    handleRequest: async function(args) {
      if (store.state.login_type != "mandate") {
        return false;
      }

      const getHeightAndWidthFromDataUrl = dataURL =>
        new Promise(resolve => {
          const img = new Image();
          img.onload = () => {
            resolve({
              height: img.height,
              width: img.width
            });
          };
          img.src = dataURL;
        });

      args.data = {
        request: {
          command: "upload",
          csrftoken: store.methods.getCSRFToken()
        }
      };

      const { onSuccess, onError, file } = args;

      const fmData = new FormData();

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      const fileAsDataURL = window.URL.createObjectURL(file);

      getHeightAndWidthFromDataUrl(fileAsDataURL).then(async dimensions => {
        if (dimensions.height > 64 || dimensions.width > 300) {
          this.$message({
            showClose: true,
            message:
              "Max dimensions (width: 300px, height: 64px). Given dimensions (width: " +
              dimensions.width +
              "px, height: " +
              dimensions.height +
              "px)",
            type: "error",
            offset: 350
          });
        } else {
          fmData.append("uploadfile", file);
          fmData.append(
            "request",
            JSON.stringify({
              command: "upload",
              csrftoken: store.methods.getCSRFToken()
            })
          );

          try {
            const path = process.env.VUE_APP_API_PATH;
            const response = await axios.post(path, fmData, config);

            const res = response.data;

            if (res.status == "success") {
              this.$message({
                showClose: true,
                message: this.$t("logo_updated"),
                type: "success",
                offset: 350
              });

              this.getLogo();
              this.imageKey++;
            } else {
              this.$message({
                showClose: true,
                message: res.errordetails,
                type: "error",
                offset: 350
              });
            }

            onSuccess("Ok");
          } catch (err) {
            onError({ err });
          }
        }
      });
    },
    TextColorChanged: function(color) {
      if (color == "") color = "#ffffff";
      this.textColor = color;
    },
    TextColorServiceChanged: function(color) {
      if (color == "") color = "#000000";
      this.textColorService = color;
    },
    TextColorTodayChanged: function(color) {
      if (color == "") color = "#000000";
      this.textColorToday = color;
    },
    TextColorAnnouncementChanged: function(color) {
      if (color == "") color = "#7F1010";
      this.textColorAnnouncement = color;
    },
    BGColorChanged: function(color) {
      if (color == "") color = "#E18324";
      this.bgColor = color;
    },
    BGColorServiceChanged: function(color) {
      if (color == "") color = "#FFFFFF";
      this.bgColorService = color;
    },
    BGColorTodayChanged: function(color) {
      if (color == "") color = "#D0D0D0";
      this.bgColorToday = color;
    },
    BGColorAnnouncementChanged: function(color) {
      if (color == "") color = "#D0D0D0";
      this.bgColorAnnouncement = color;
    },
    async save() {
      if (this.password != "" && this.old_password != "") {
        const response = await store.methods.apiRequest("changepassword", {
          oldpassword: this.old_password,
          newpassword: this.password
        });

        const res = response.data;

        if (res.status == "success") {
          this.$message({
            showClose: true,
            message: this.$t("password_updated"),
            type: "success",
            offset: 350
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t("old_password_missmatch"),
            type: "error",
            offset: 350
          });
        }
      }

      if (store.state.login_type == "mandate") {
        const response_c = await store.methods.apiRequest("changecolors", {
          fgcolor: this.textColor,
          bgcolor: this.bgColor,
          service_fgcolor: this.textColorService,
          service_bgcolor: this.bgColorService,
          weekdaytoday_bgcolor: this.bgColorToday,
          weekdaytoday_fgcolor: this.textColorToday,
          announcement_fgcolor: this.textColorAnnouncement,
          announcement_bgcolor: this.bgColorAnnouncement
        });

        const res_c = response_c.data;

        if (res_c.status == "success") {
          this.$message({
            showClose: true,
            message: this.$t("colors_updated"),
            type: "success",
            offset: 350
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t("colors_update_error"),
            type: "error",
            offset: 350
          });
        }
      }
    },
    save_settings(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (store.state.login_type == "mandate") {
            if (!this.enable_notices) {
              this.email_notification_notice = false;
            }
            const settingobject = {
              send_email_on_add: this.email_notification ? 1 : 0,
              noticesfield: this.enable_notices ? 1 : 0,
              send_email_on_notice: this.email_notification_notice ? 1 : 0,
              showannoucement_inrange_day: parseInt(
                this.ruleForm.showannoucement_inrange_day
              )
            };
            if (settingobject.send_email_on_add == 1) {
              settingobject.send_email_on_add_address = this.ruleForm.email;
            }
            if (settingobject.send_email_on_notice == 1) {
              settingobject.send_email_on_notice_address = this.ruleForm.email_notice;
            }

            const response_c = await store.methods.apiRequest(
              "save_settings",
              settingobject
            );
            store.methods.setNoticesField(this.enable_notices);
            const res_c = response_c.data;

            if (res_c.status == "success") {
              this.$message({
                showClose: true,
                message: this.$t("save_settings"),
                type: "success",
                offset: 350
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t("save_settings_error"),
                type: "error",
                offset: 350
              });
            }
          }
        }
      });
    },
    testEmailasList(emails) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const list = emails.split(",");
      console.log("start");
      let status = true;
      list.forEach(s => {
        if (!re.test(String(s).toLowerCase())) {
          status = false;
        }
      });
      return status;
    },
    async getLogo() {
      const response = await store.methods.apiRequest("getlogo");

      const res = response.data;

      if (res.status == "success" && res.results && res.results.location) {
        this.logo = process.env.VUE_APP_API_PATH + res.results.location;
      }
    },
    async deleteLogo() {
      const response = await store.methods.apiRequest("deletelogo");

      const res = response.data;

      if (res.status == "success") {
        this.logo = null;
        this.imageKey = this.imageKey + 1;

        this.$message({
          showClose: true,
          message: this.$t("logo_deleted"),
          type: "success",
          offset: 350
        });
      }
    },
    async getSettings() {
      const response = await store.methods.apiRequest("getsettings");
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results) {
        const r = res.results;
        this.bgColor = r.bgcolor;
        this.textColor = r.fgcolor;
        this.textColorService = r.service_fgcolor;
        this.bgColorService = r.service_bgcolor;
        this.bgColorToday = r.weekdaytoday_bgcolor;
        this.textColorToday = r.weekdaytoday_fgcolor;
        this.textColorAnnouncement = r.announcement_fgcolor;
        this.bgColorAnnouncement = r.announcement_bgcolor;
        if (r.send_email_on_add) {
          this.email_notification = false;
          if (r.send_email_on_add == "1") {
            this.email_notification = true;
          }
        }
        if (r.send_email_on_add_address) {
          this.ruleForm.email = r.send_email_on_add_address;
        }
        this.showannoucement_inrange_day = -1;
        if (r.showannoucement_inrange_day) {
          this.showannoucement_inrange_day = parseInt(
            r.showannoucement_inrange_day
          );
          this.ruleForm.showannoucement_inrange_day = this.showannoucement_inrange_day;
        }

        if (r.noticesfield) {
          this.enable_notices = false;
          if (r.noticesfield == "1") {
            this.enable_notices = true;
          }
          if (r.send_email_on_notice) {
            this.email_notification_notice = false;
            if (r.send_email_on_notice == "1") {
              this.email_notification_notice = true;
            }
          }
          if (r.send_email_on_notice_address) {
            this.ruleForm.email_notice = r.send_email_on_notice_address;
          }
        } else {
          this.enable_notices = false;
          this.email_notification_notice = false;
          this.ruleForm.email_notice = "";
        }
      }
    }
  },
  async mounted() {
    this.getLogo();
    this.getSettings();
  }
};
</script>
